import Navbar from "@/pages/home/components/Navbar";
import Hero from "@/pages/home/components/Hero";
import FeaturedSection from "@/pages/home/components/FeaturedSection";
import GenreFeatureSection from "@/pages/home/components/GenreFeatureSection";
import TvSection from "@/pages/home/components/TvSection";
import ClassicSection from "@/pages/home/components/ClassicSection";
import CollectionsSection from "@/pages/home/components/CollectionsSection";
import RankingSection from "@/pages/home/components/RankingSection";
import GuideSection from "@/pages/home/components/GuideSection";
import FaqSection from "@/pages/home/components/FaqSection";
import Footer from "@/pages/home/components/Footer";
import { actionFilms, scifiFilms } from "@/mocks/home";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50">
      <Navbar />
      <main>
        <Hero />

        <FeaturedSection />

        <GenreFeatureSection
          id="action"
          eyebrow="动作片"
          title="打斗、追车、爆破，节奏拉满的那种"
          desc="动作片的核心是身体与空间的调度。下面这份片单从写实格斗到高速追车都有覆盖，时长普遍在两个小时以内，适合想直接进入状态的时候看。"
          tone="primary"
          films={actionFilms}
          imageSide="right"
          bgClass="bg-background-50"
        />

        <GenreFeatureSection
          id="scifi"
          eyebrow="科幻片"
          title="从太空到梦境，把想象力铺到最大"
          desc="科幻片分两种：一种偏设定与思辨，一种偏视觉与氛围。这一区把两类都收进来，你可以按当晚是想动脑还是想看画面来选。"
          tone="secondary"
          films={scifiFilms}
          imageSide="left"
          bgClass="bg-background-100"
        />

        <TvSection />

        <ClassicSection />

        <CollectionsSection />

        <RankingSection />

        <GuideSection />

        <FaqSection />
      </main>
      <Footer />
    </div>
  );
}